<template>
  <div class="ma-10">
    <v-dialog
      v-model="showCategoryPopup"
      max-width="400"
      persistent
    >
      <v-card>
        <v-card-title class="modal-title">
          Pilih Kategori
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="category in listCategory"
              :key="category.value"
              @click="selectCategory(category.value)"
              :class="{ 'selected-category': filter.category === category.value }"
            >
              <v-list-item-title>{{ category.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#3b54d9"
            text
            @click="clearCategory"
          >
            Clear Filter
          </v-btn>
          <v-btn
            color="#3b54d9"
            text
            @click="showCategoryPopup = false"
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Loading v-if="isLoading" />
    <Popup
      :message="message"
      v-if="isPopup"
      @close="() => (isPopup = false)"
    />
    <div class="top-container-box">
      <h1>Project Portfolio</h1>
      <div>
        <Button
          icon="+"
          outline
          name="Buat Portofolio Baru"
          style="background-color: #3b54d9; color: #ffffff; width: 270px"
          @click="() => $router.push('/project-portfolio/new')"
        />
      </div>
    </div>
    <v-row>
      <v-col cols="6">
        <div class="action-head">
          <div class="f-search">
            <div>
              <v-text-field
                v-model="filter.program"
                type="text"
                class="f-input"
                placeholder="Cari Project..."
                clearable
                dense
                flat
                solo
                style="
                  padding-top: 5px;
                  padding-left: 5px;
                  width: 448px;
                  border-radius: 14px;
                "
                @input="() => getProjectPortfolios()"
              ></v-text-field>
            </div>
            <div class="f-search-ic">
              <img
                src="/img/icons/search.png"
                style="width: 100%"
                alt="Search Ic"
              />
            </div>
          </div>
          <v-btn
            class="ml-4"
            color="#3b54d9"
            style="color: #ffffff; border-radius: 10px"
            @click="showCategoryPopup = true"
          >
            Filter Kategori
          </v-btn>
        </div>
      </v-col>
      
    </v-row>
    <NewTable
      :headers="headers"
      :rows="projectPortfolios"
      :currentPage="currentPage"
      :totalPages="total"
      :totalData="totalData"
      :customColumns="customColumns"
      :perPage="perPage"
      :onEdit="editItem"
      :onView="watchItem"
      :onDelete="onDelete"
      :onPageChange="getProjectPortfolios"
    />
  </div>
</template>

<script>
import moment from "moment";
import Button from "@/components/Button.vue";
import Loading from "@/components/ilustration/Loading.vue";
import Popup from "@/components/others/Popup.vue";
import NewTable from "@/components/Tabel.vue";
import getAuthentification from "@/utils/badrequest.js";

export default {
  name: "ProjectPortfolio",
  components: {
    Button,
    Loading,
    Popup,
    NewTable,
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      total: 0,
      perPage: 10,
      totalData: 0,
      message: "",
      isPopup: false,
      filter: {
        program: "",
        sort_by: "desc",
        category: "",
        start_date: "",
        end_date: "",
        date: [],
      },
      showCategoryPopup: false,
      listCategory: [
            {
              name: "Collaboration",
              value: "COLLABORATION",
            },
            {
              name: "Training",
              value: "TRAINING",
            },
            {
              name: "Talent Service",
              value: "TALENT_SERVICE",
            },
            {
              name: "Services",
              value: "SERVICES",
            },
          ],
      headers: [
        {
          text: "PROJECT PORTOFOLIO",
          field: "program",
          width: 300,
        },
        {
          text: "KATEGORI",
          field: "category",
          width: 300,
        },
        {
          text: "KLIEN",
          field: "title",
          width: 300,
        },
        {
          text: "TIMELINE",
          field: "start_date",
          width: 150,
        },
        {
          text: "DEVICE",
          field: "device",
          width: 280,
        },
      ],
      projectPortfolios: [],
      customColumns: [
        {
          field: "start_date",
          render: (row) => {
            return this.$helpers.getYear(row.start_date);
          },
        },
        {
          field: "device",
          render: (row) => {
            return row.device.map(item => item.name).join(", ");
          },
        },
      ],
    };
  },
  methods: {
    async getProjectPortfolios(page) {
      if (!page) page = this.currentPage;
      else this.currentPage = page;

      this.isLoading = true;
      try {
        const response = await this.$crm_http.get(
          `/v1/project-portfolio?page=${page}&per_page=${this.perPage}&program=${this.filter.program || ""}&sort_by=${this.filter.sort_by}&category=${this.filter.category || ""}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`
        );
        this.projectPortfolios = response.data.data.project_portfolios.map((item) => ({
          id: item.id,
          program: item.program,
          title: item.title,
          category: item.category,
          start_date: item.start_date,
          device: item.device,
        }));
        const t = parseInt(response.data.data.total);
        this.total = Math.ceil(t / this.perPage);
        this.totalData = response.data.data.total;
        if (this.currentPage > this.total) {
          this.currentPage = this.total;
          this.getProjectPortfolios();
        }
      } catch (err) {
        this.message = err.response.data.data;
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    watchItem(id) {
      this.$router.push("/project-portfolio/watch/" + id);
    },
    editItem(id) {
      this.$router.push("/project-portfolio/edit/" + id);
    },
    async onDelete(id) {
      this.isLoading = true;
      try {
        await this.$crm_http.delete("/v1/project-portfolio/" + id);
        this.getProjectPortfolios();
      } catch (err) {
        this.message = err.response.data.data;
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    updateIsFilterActive() {
      this.isFilterActive = !(
        this.filter.sort_by === "desc" &&
        !this.filter.program &&
        !this.filter.category &&
        !this.filter.start_date &&
        !this.filter.end_date
      );
    },
    selectCategory(value) {
      this.filter.category = value;
      this.showCategoryPopup = false;
      this.getProjectPortfolios();
      this.updateIsFilterActive();
    },
    clearCategory() {
      this.filter.category = "";
      this.showCategoryPopup = false;
      this.getProjectPortfolios();
      this.updateIsFilterActive();
    },
  },
  beforeCreate() {
    getAuthentification();
  },
  mounted() {
    this.getProjectPortfolios();
  },
};
</script>

<style scoped>
.action-head {
  margin-top: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-title {
  font-weight: bold;
  font-size: 19px;
}
.f-search {
  border: 1px solid #d3d6e1;
  width: 100%;
  height: 48px;
  gap: 10px;
  display: flex;
  border-radius: 10px;
  background-color: white;
}
.f-search-ic {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  margin-right: 18px;
}
.f-input {
  width: 86%;
  background: transparent;
  border: none;
}
.f-input:focus {
  background: transparent;
  border: none;
  outline-width: 0;
}
.top-container-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.count-data {
  position: relative;
  top: -60px;
  width: 30%;
}
.no-pagination {
  margin-top: 20px;
  margin-left: 5px;
}
.selected-category {
  background-color: #e3f2fd;
  color: #3b54d9;
}
</style>